/**
 * P34 (Feb 27, 2026) — Rhinobill-style claims tabs.
 *
 * Three lifecycle views into the claims roster:
 *   - Recent : everything, newest first (default landing)
 *   - Drafts : status = Draft (unsubmitted work-in-progress)
 *   - Issues : status NOT IN (Paid, Draft, Voided) — anything that still
 *              needs biller attention (Submitted / Accepted / Pending /
 *              Rejected / Denied / Partially Paid / etc.)
 */
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../../components/ui/tabs';

const TABS = [
  { value: 'recent', label: 'Recent', testid: 'tab-recent' },
  { value: 'drafts', label: 'Drafts', testid: 'tab-drafts' },
  { value: 'issues', label: 'Issues', testid: 'tab-issues' },
];

const ClaimsTabs = ({ activeTab, onChange, counts = {} }) => (
  <Tabs value={activeTab} onValueChange={onChange} data-testid="claims-tabs">
    <TabsList className="bg-slate-100">
      {TABS.map(({ value, label, testid }) => (
        <TabsTrigger key={value} value={value} data-testid={testid}>
          {label}
          {typeof counts[value] === 'number' ? (
            <span className="ml-2 text-xs text-slate-500" data-testid={`${testid}-count`}>
              ({counts[value]})
            </span>
          ) : null}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
);

export default ClaimsTabs;
